<template>
	<div>
    <div class="m_context">
		<el-row :gutter="0" style="margin-bottom:20px;">
					<el-col :span="12" style="padding-left: 24px;">
						<el-button type="primary" @click="upload" icon="upload">{{$t('lin_global.upload')}}</el-button>
					</el-col>

					

					<el-col :span="4" style="padding-right:16px;">
						<div class=''>
						  <MechanismSelector :data="mechanismData" classs="''"></MechanismSelector>
						</div>
					</el-col>

					<el-col :span="4" style="">
						<div class=''>
								<el-select v-model="selectType" @change="typeChange" placeholder="" style='width:calc(100% - 18px);'>
									<el-option
										v-for="item in type"
										:label="item.label"
										:value="item.value"
										:key="item.id">
									</el-option>
								</el-select>
						</div>
					</el-col>

					<el-col :span="4" style="">
						<div style='padding-right:24px;'>
						<el-input

								:placeholder="$t('lin_global.tgmccz')"
							icon="search"
							v-model="name"
							:on-icon-click="handleIconClick"
							@keyup.enter.native="focusEvent(handleIconClick)">
						</el-input>
						</div>
					</el-col>
	        
					
		</el-row>
     <el-table
	  	:data="arrdata"
	  	border
	  	style="width: 100%"
	  	ref="arrdata">
	  		<el-table-column
	  		prop="name"
	  		:label="$t('lin_global.name')"
				min-width="150">
	  		</el-table-column>
	  		<el-table-column
	  		prop="version"
        :label="$t('lin_global.version')"
	  		width="100">
	  		</el-table-column>
	  		<!--<el-table-column
	  		prop="status"
	  		label="状态"
	  		width="150"
	  		:formatter="formatStatus">
	  		</el-table-column>-->
       <el-table-column
         :label="$t('lin_global.status')"
         width="">
         <template slot-scope="scope">
           <span v-if="scope.row.status == 0" style="color: #8492A6;">{{$t('lin_global.waitOne')}}</span>
           <span v-if="scope.row.status == 1" style="color: #F7BA2A;">{{$t('lin_global.waitTwo')}}</span>
           <span v-if="scope.row.status == 2" style="color:#13CE66;">{{$t('lin_global.verifyPass')}}</span>
           <span v-if="scope.row.status == 3" style="color: #FF4949;">{{$t('lin_global.verifyNotPass')}}</span>
           <el-popover v-if="scope.row.ifInfor" trigger="hover" placement="top">
              <p>{{ scope.row.auditContent }}</p>
              <span slot="reference" class="name-wrapper">
              <el-icon style="cursor: pointer;color: #58B7FF;" v-if="scope.row.ifInfor" name="information"></el-icon>
              </span>
           </el-popover>
         </template>
       </el-table-column>
	  		<el-table-column
	  		prop="type"
        :label="$t('terminal.details.animatType')"
	  		width="">
				  <template slot-scope='scope'>
						<label>{{otaUdType(scope.row.updateType)}}</label>
					</template>
	  		</el-table-column>
	  		<el-table-column
	  		prop="mechanismName"
        :label="$t('lin_global.label_areaid')">
	  		</el-table-column>
				<el-table-column
	  		prop="size"
        :label="$t('app_fileSize')"
	  		width="100">
	  		</el-table-column>
				<el-table-column
	  		prop="md5"
        label="MD5"
	  		width="200">
	  		</el-table-column>
	  		<el-table-column
	  		prop="download"
        :label="$t('lin_global.downNumber')"
	  		width="">
	  		</el-table-column>
	  		<el-table-column
				  header-align="center"
				  align='right'
          :label="$t('lin_global.ope')" width="">
				<template slot-scope="scope">

					<!-- <el-tooltip v-show="scope.row.status === 2" class="item" effect="dark" :content="$t('app_push')" placement="top">
						<el-button type='text'  @click="push(scope.row)"><i class="fa fa-upload" style=""></i></el-button>
					</el-tooltip> -->

					<!-- <el-button v-if="scope.row.submit" @click="submitRow(scope.row.id)" type="text">{{$t('lin_global.smVerify')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_global.smVerify')" placement="top">
						<el-button type='text' v-if="scope.row.submit" @click="submitRow(scope.row.id)"><i class="fa fa-external-link-square" style=""></i></el-button>
					</el-tooltip>

					<!-- <el-button v-if="scope.row.edit" @click="editRow(scope.row.id)" type="text">{{$t('lin_btn.edit')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.edit')" placement="top">
						<el-button type='text' v-if="scope.row.edit" @click="editRow(scope.row.id)"><i class="fa fa-pencil" style=""></i></el-button>
					</el-tooltip>

					<!-- <el-button v-if="scope.row.delete" @click="deleteRow(scope.row.id)" type="text">{{$t('lin_btn.delete')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.delete')" placement="top">
						<el-button type='text' v-if="scope.row.delete" @click="deleteRow(scope.row.id)"><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
					</el-tooltip>
				</template>
	  		</el-table-column>
	  	</el-table>
	  	<div class="page_content" v-if="totalRecords > 0">
		  <el-pagination style='float:right;'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="[10,50,100]"
		    :page-size="pageSize"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords">
		  </el-pagination>
		</div>
    </div>
	</div>
</template>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import axios from 'axios'
    import { baseurl,focusEvent } from '../../api/url'
	export default{
		components: {
      MechanismSelector
    },
		data(){
			var that = this
			return{
				mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.mech = value
            that.selectChange()
						
          }
        },
				focusEvent: focusEvent,
				selectType:'',
				arrdata:[],
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				mech: '',
				name:'',
				type: [{
			        value: '',
			        label: this.$t('lin_global.allType')
			      }, {
			        value: '0',
			        label: this.$t('app_ttPkg')
			      }, {
			        value: '1',
			        label: this.$t('app_dfPkg')
			    }]
			}
		},
		created(){
			this.getData(1,'')
		},
		methods:{
			selectChange () {
				this.getData(this.currentPage,this.name)
			},
			push (row) {
				
				this.$setWObj('pushList', {type: '2' ,data:row})
				this.$router.push({path: '/romList/romPush'})
			},
			otaUdType (key) {
				var vls = {'0': this.$t('app_ttPkg'), '1': this.$t('app_dfPkg')}
				return vls[key]
			},
			submitRow:function(id){
				let token = localStorage.getItem('user');
				var params = {token:token,ota_rom_id:id,content:'',status:1};
				this.$confirm(this.$t('lin_global.qdtjsh'), this.$t('lin_btn.tips'), {
		          confirmButtonText: this.$t('lin_btn.confirm'),
		          cancelButtonText: this.$t('lin_btn.cancel'),
		          type: 'warning'
		        }).then(() => {
					axios.post(`${baseurl}/ota_rom/audit.do`,params).then(res=>{
						//console.log("提交审核返回参数")
						//console.log(res.data)
			          	if (res.data.status == 200) {
			              this.$message.success(this.$t('lin_global.tjshcg'))
			              this.getData(1,'')
			            } else {
			              this.$message.error(res.data.message)
			            }
			        })
		        }).catch(() => {

        })
			},
			editRow:function(id){
				this.$router.push({ path: '/romList/'+id+'/edit' })
			},
			deleteRow:function(id){
				var params = {ids:id}
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
		          confirmButtonText: this.$t('lin_btn.confirm'),
		          cancelButtonText: this.$t('lin_btn.cancel'),
		          type: 'warning'
		        }).then(() => {
		          axios.post(`${baseurl}/ota_rom/delete.do`,params).then(res=>{
		          	if (res.data.status == 200) {
		              this.$message.success(this.$t('lin_global.delete_success'))
		              this.getData(1,'')
		            } else {
		              this.$message.error(res.data.message)
		            }
		          })
		        }).catch(() => {

        })
			},
			upload:function(){
				this.$router.push({path:'/romList/upload'})
			},
			typeChange:function(){
				this.getData(1,this.name);
			},
			handleIconClick:function(){
				this.getData(1,this.name);
			},
			handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getData(this.currentPage,'')
		        //console.log(`每页 ${val} 条`)
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getData(this.currentPage,'')
		        //console.log('当前页: ${val}')
		    },
			getData:function(page,name){
				this.currentPage = page;
				var mid = this.mech ? this.mech : ''
				var params = {page:page,rows:this.pageSize,type:this.selectType,name:name,status:'',memo:'', mechId: mid};
				//console.log("看看是何方参数");
				console.log('param', params);
				axios.post(`${baseurl}/ota_rom/list.do`,params).then(res=>{
					//console.log("打印返回ORM列表")
					console.log(res.data);
					this.arrdata = res.data.data;
					this.totalRecords = res.data.total;
					for(var i = 0;i<res.data.data.length;i++){
						if(res.data.data[i].status == 0){
							res.data.data[i]['submit'] = true;
							res.data.data[i]['edit'] = true;
							res.data.data[i]['delete'] = true;
              res.data.data[i]['ifInfor'] = false;
						}else if(res.data.data[i].status == 1){
							res.data.data[i]['submit'] = false;
							res.data.data[i]['edit'] = false;
							res.data.data[i]['delete'] = false;
              res.data.data[i]['ifInfor'] = false;
						}else if(res.data.data[i].status == 2){
							res.data.data[i]['submit'] = false;
							res.data.data[i]['edit'] = false;
							res.data.data[i]['delete'] = true;
              res.data.data[i]['ifInfor'] = false;
						}else if(res.data.data[i].status == 3){
							res.data.data[i]['submit'] = false;
							res.data.data[i]['edit'] = true;
							res.data.data[i]['delete'] = true;
              res.data.data[i]['ifInfor'] = true;
						}else{
							return false
						}
					}
				})
			},
			formatStatus:function(row,column){
		      return row.status == 0?this.$t('lin_global.waitOne'):row.status == 1?this.$t('lin_global.waitTwo'):row.status == 2?this.$t('lin_global.verifyPass'):row.status == 3?this.$t('lin_global.verifyNotPass'):'';
		    },
		}
	}
</script>



// WEBPACK FOOTER //
// romList.vue?0a10a5de